module.exports = __webpack_public_path__ + "jtails-build/img/404.b437dc90.svg";